module.exports = __webpack_public_path__ + "static/media/banner-img.30a8d95f.png";